import { FileCheck2, PhoneCall, Truck, Timer } from "lucide-react";
import { SectionHeading, Reveal } from "@/components/Reveal";

const TRUTH = [
  {
    icon: FileCheck2,
    title: "Contract-First Capacity",
    desc: "We don't take once-off erratic consumer errands. Our fleet is reserved for committed corporate routes, daily manifests and SLAs.",
  },
  {
    icon: PhoneCall,
    title: "Owner-Managed Accountability",
    desc: "Direct communication lines with dispatch decision-makers. No call-centre runarounds when urgent load contingencies happen.",
  },
  {
    icon: Truck,
    title: "Bakkie & Van Fleet Readiness",
    desc: "Versatile light commercial delivery vehicles ideal for urban access, tight delivery gates and rapid-turnaround regional distribution.",
  },
  {
    icon: Timer,
    title: "48–72H Mobilisation",
    desc: "On signed scope and SLA verification, dedicated vehicles can be assigned to scheduled runs within 48 to 72 hours.",
  },
];

export const WhyPartner = () => (
  <section id="why" className="scroll-mt-24 py-20 md:py-28" data-testid="why-section">
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <SectionHeading
        eyebrow="Why Partner With NGCONDE"
        title="A contractor that treats your routes like our own."
        intro="Operations teams keep us because we show up, communicate and document. Procurement teams keep us because the paperwork matches the performance."
      />

      <div className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {TRUTH.map((t, i) => (
          <Reveal key={t.title} delay={i * 0.08} className="h-full">
            <article
              data-testid={`why-card-${i + 1}`}
              className="group flex h-full flex-col rounded-2xl border border-white/10 bg-[#0D1424] p-6 transition-all duration-300 hover:-translate-y-1 hover:border-[#FF6B00]/60 hover:shadow-[0_12px_40px_rgba(255,107,0,0.12)] md:p-7"
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-[#FF6B00]/10 text-[#FF6B00] transition-colors duration-300 group-hover:bg-[#FF6B00] group-hover:text-[#080C14]">
                <t.icon className="h-6 w-6" />
              </span>
              <h3 className="mt-6 font-display text-lg font-extrabold uppercase tracking-tight text-white">
                {t.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-slate-400">{t.desc}</p>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
